<template>
  <div class="h-100">
    <offline-indicator />
    <component v-bind:is="layout"/>
  </div>
</template>

<script>
import BaseLayout from './layouts/BaseLayout'
import OfflineIndicator from './components/OfflineIndicator'

export default {
  computed: {
    layout () {
      return this.$store.getters['app/layout']
    }
  },
  components: {
    'base-layout': BaseLayout,
    'offline-indicator': OfflineIndicator,
  },
 
}
</script>
